import React, { useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { DemoBar } from './components/DemoBar';
import { Demo } from './pages/Demo';
import { Specs } from './pages/Specs';
function Shell() {
  const [scenarioId, setScenarioId] = useState('payment_standard');
  const navigate = useNavigate();
  return <div className="min-h-full w-full bg-ink-100" data-id="element-0" data-mp="3f8ezxm85fxv9">
      <DemoBar activeId={scenarioId} onSelect={id => {
      setScenarioId(id);
      navigate('/');
    }} data-id="element-1" data-mp="2rk46h44s90h0" />
      <Routes data-id="element-2" data-mp="2mjpvbd7vxaer">
        <Route path="/specs" element={<Specs data-id="element-4" data-mp="31b8gdpflpv4z" />} data-id="element-3" data-mp="2mjzplczyq3q9" />
        <Route path="*" element={<Demo scenarioId={scenarioId} data-id="element-6" data-mp="31c1jmgfcq2id" />} data-id="element-5" data-mp="31bib1qblcqh0" />
      </Routes>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-7" data-mp="2whxabqim5ie4">
      <Shell data-id="element-8" data-mp="28ufmg62gz4gf" />
    </BrowserRouter>;
}